export function buildQueryString(payload) {
  if (!payload) {
    return '';
  }
  const summaryParams = new URLSearchParams();

  Object.keys(payload).forEach((key) => {
    const val = payload[key];
    if (Array.isArray(val)) {
      val.forEach((v) => {
        summaryParams.append(key, v);
      });

      return;
    }
    summaryParams.append(key, val);
  });

  return summaryParams;
}
